(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["last-visited-collections"]) return;
  try {
    
const currentCollectionHandle = window.location.pathname;

if (currentCollectionHandle.includes('/collections/')) {
    let visitedCollections = JSON.parse(localStorage.getItem('visitedCollections')) || [];
    if (!visitedCollections.includes(currentCollectionHandle)) {
        visitedCollections.push(currentCollectionHandle);
        while (visitedCollections.length > 5) {
            visitedCollections.shift();
        }
        localStorage.setItem('visitedCollections', JSON.stringify(visitedCollections));
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const collectionsGrid = document.getElementById('collections-grid');
    if (!collectionsGrid) return;

    const visitedCollections = JSON.parse(localStorage.getItem('visitedCollections')) || [];
    console.log('Visited collections from local storage:', visitedCollections);

    visitedCollections.forEach(handle => {
        const collectionHandle = handle.split('/collections/')[1];
        console.log('Fetching details for:', collectionHandle);

        fetch(`/collections/${collectionHandle}.json`)
        .then(response => response.json())
        .then(data => {
            console.log('Fetched data:', data);
            const collection = data.collection;
            
            let imageSrc = collection.image ? collection.image.src : 'path/to/default/image.jpg';
            console.log('Image Source:', imageSrc);

            const collectionElement = `
            <a href="/collections/${collection.handle}" class="collection-card">
                <img src="${imageSrc}" alt="${collection.title}" style="width: 100px;">
                <p>${collection.title}</p>
            </a>`;
            
            collectionsGrid.insertAdjacentHTML('beforeend', collectionElement);
        })
        .catch(error => {
            console.error('Error fetching collection:', error);
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
